import { render, staticRenderFns } from "./Aggregate.vue?vue&type=template&id=096d342e&scoped=true&"
import script from "./Aggregate.vue?vue&type=script&lang=js&"
export * from "./Aggregate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d342e",
  null
  
)

export default component.exports